var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column page-layout"},[_c('h1',[_vm._v("RTP Variants")])])
}
var staticRenderFns = []

export { render, staticRenderFns }